import { render, staticRenderFns } from "./dueDiligenceRemediationMonitoringTabComponent.vue?vue&type=template&id=48da114d&scoped=true"
import script from "./dueDiligenceRemediationMonitoringTabComponent.vue?vue&type=script&lang=js"
export * from "./dueDiligenceRemediationMonitoringTabComponent.vue?vue&type=script&lang=js"
import style0 from "./dueDiligenceRemediationMonitoringTabComponent.vue?vue&type=style&index=0&id=48da114d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48da114d",
  null
  
)

export default component.exports